import { AuthorityDefaultSettingPage } from "./AuthorityDefaultSettingPage";
export default AuthorityDefaultSettingPage;
